import { FabricObject } from 'fabric';
import { initializeMnemonicFabricRuntime } from './fabric-serialization.config';
import { MnemonicCanvasSaveOptions, MnemonicFabricCanvas } from './fabric-canvas.types';
import { enrichMnemonicCanvasForSave } from './fabric-object.enricher';

export function serializeMnemonicCanvas(canvas: MnemonicFabricCanvas, options: MnemonicCanvasSaveOptions = {}): Record<string, unknown> {
    initializeMnemonicFabricRuntime();

    const json = canvas.toJSON() as Record<string, unknown>;

    return enrichMnemonicCanvasForSave(json, canvas.getObjects() as FabricObject[], canvas.backgroundImage, options);
}
